import React, { useEffect, useRef, useState } from "react";
import style from "./style.module.css";
import Image from "next/image";
import { buildListingTitle } from "utils/generateFeeds/generateRssFeed";
import { set_size } from "utils/getImageToDisplay";
import ActiveDotsAsIndexes from "components/v3/Listings/ListingFullDisplay/components/ActiveDotsAsIndexes";
import VoirPlusCard from "../../SearchBarComponent/components/ListingsPopup/VoirPlusCard";
import { buildListingUrl } from "../../ListingsRouterUrlHelper";
import MoreDetails from "../MoreDetails";

function index({
  listing,
  t,
  lang,
  showDesc,
  mapVsList,
  priority,
}: {
  listing: any;
  t: any;
  lang: string;
  showDesc: boolean;
  mapVsList: any;
  priority?: any;
}) {
  const imgRef = useRef(null);

  const buildUrlImageWithOperations = (
    url,
    apply_operations = true,
    operations = [
      {
        operation: "output",
        format: "webp",
      },
    ]
  ) => {
    if (apply_operations) {
      return `https://us-central1-agenz-website-prod.cloudfunctions.net/ext-image-processing-api-handler/process?operations=${encodeURIComponent(
        JSON.stringify([
          { operation: "input", type: "url", url: url },
          ...operations,
        ])
      )}`;
    } else {
      return set_size(url);
    }
  };

  const [indImg, setImgInd] = useState<number>(1);
  const [imgLength, setImgLength] = useState<number>(listing.images.length);

  // const [isMobile, setIsMobile] = useState(false);
  const [rightMove, setRightMove] = useState(false);
  const [leftMove, setLeftMove] = useState(false);

  function logit() {
    const slider = imgRef.current;

    if (window.innerWidth > 990) {
      if (imgLength < 10) {
        setImgInd(
          Math.min(
            imgLength,
            Math.max(1, Math.floor(slider.scrollLeft / 400) + 1) > 10
              ? Math.max(1, Math.floor(slider.scrollLeft / 400) + 1) - 1
              : Math.max(1, Math.floor(slider.scrollLeft / 400) + 1)
          )
        );
      } else {
        setImgInd(
          Math.min(
            imgLength + 1,
            Math.max(1, Math.floor(slider.scrollLeft / 400) + 1) > 11
              ? Math.max(1, Math.floor(slider.scrollLeft / 400) + 1) - 1
              : Math.max(1, Math.floor(slider.scrollLeft / 400) + 1)
          )
        );
      }
    } else {
      if (imgLength < 10) {
        setImgInd(
          Math.min(
            imgLength,
            Math.max(
              1,
              Math.floor(slider.scrollLeft / (window.innerWidth - 32)) + 1
            ) > 10
              ? Math.max(
                  1,
                  Math.floor(slider.scrollLeft / (window.innerWidth - 32)) + 1
                ) - 1
              : Math.max(
                  1,
                  Math.floor(slider.scrollLeft / (window.innerWidth - 32)) + 1
                )
          )
        );
      } else {
        setImgInd(
          Math.min(
            imgLength + 1,
            Math.max(
              1,
              Math.floor(slider.scrollLeft / (window.innerWidth - 32)) + 1
            ) > 11
              ? Math.max(
                  1,
                  Math.floor(slider.scrollLeft / (window.innerWidth - 32)) + 1
                ) - 1
              : Math.max(
                  1,
                  Math.floor(slider.scrollLeft / (window.innerWidth - 32)) + 1
                )
          )
        );
      }
    }
  }
  useEffect(() => {
    const slider = imgRef.current;

    function watchScroll() {
      if (slider) {
        slider.addEventListener("scroll", logit);
      }
    }
    watchScroll();
    return () => {
      if (slider) {
        slider.removeEventListener("scroll", logit);
      }
    };
  }, []);

  // useEffect(() => {
  //     const checkMobile = () => {
  //         setIsMobile(window.innerWidth <= 990);
  //     };

  //     checkMobile();
  //     window.addEventListener('resize', checkMobile);

  //     return () => window.removeEventListener('resize', checkMobile);
  // }, []);

  useEffect(() => {
    setRightMove(indImg < imgLength || (imgLength == 10 && indImg == 10));
    setLeftMove(indImg > 1);
  }, [indImg, imgLength]);

  const scrollToRight = () => {
    if (indImg == imgLength && imgLength != 10) {
      imgRef?.current ? (imgRef.current.scrollLeft = 0) : null;
    } else {
      imgRef?.current
        ? (imgRef.current.scrollLeft = imgRef.current.scrollLeft + 400)
        : null;
      // if (window.innerWidth > 990){
      //     imgRef?.current ? imgRef.current.scrollLeft = imgRef.current.scrollLeft + 400 : null;
      // }else{
      //     imgRef?.current ? imgRef.current.scrollLeft = imgRef.current.scrollLeft + (window.innerWidth - 32) : null;
      // }
    }
  };
  const scrollToLeft = () => {
    if (indImg == 0) {
      imgRef?.current ? (imgRef.current.scrollLeft = 0) : null;
    } else {
      imgRef?.current
        ? (imgRef.current.scrollLeft = imgRef.current.scrollLeft - 400)
        : null;
      // if (window.innerWidth > 990){
      //     imgRef?.current ? imgRef.current.scrollLeft = imgRef.current.scrollLeft - 400 : null;
      // }else{
      //     imgRef?.current ? imgRef.current.scrollLeft = imgRef.current.scrollLeft - (window.innerWidth - 32) : null;
      // }
    }
  };
  return (
    <>
      <div className={style.photoSection}>
        <div ref={imgRef} className={style.images}>
          {listing.images.map((image, idx) => {
            return (
              <>
                <Image
                  key={idx}
                  unoptimized
                  priority={priority && idx == 0}
                  // priority={false}
                  alt={buildListingTitle(listing, t, lang)}
                  // fill
                  width={0}
                  height={245}
                  style={{
                    objectFit: "cover",
                    objectPosition: "center",
                    width: "100%",
                    minWidth: "100%",
                    scrollSnapAlign: "start",
                  }}
                  src={
                    typeof image == "string"
                      ? buildUrlImageWithOperations(image, false)
                      : image
                      ? buildUrlImageWithOperations(image, false)
                      : "https://storage.googleapis.com/headers-agenz/logo-agenz/agenz-logo-white.png"
                  }
                />
              </>
            );
          })}
          {imgLength >= 10 ? (
            <>
              <MoreDetails
                t={t}
                lang={lang}
                link={buildListingUrl(
                  listing,
                  lang,
                  null,
                  null,
                  mapVsList,
                  true
                )}
                listing={listing}
                image={listing.images[0]}
                buildUrlImageWithOperations={buildUrlImageWithOperations}
              />
            </>
          ) : null}
        </div>
        {/* <span
                data-tracking="click"
                data-value="number-images-annonce"
                className={style.imageIndexes}
            >
                {indImg + " sur " + imgLength}
            </span> */}
        {/* <div className={style.arrows}> */}
        {rightMove ? (
          <span
            className={style.arrowRight}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              scrollToRight();
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
            >
              <path
                d="M6.75 3.75L12 9L6.75 14.25"
                stroke="#00111A"
                stroke-width="1.2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
        ) : null}
        {leftMove ? (
          <span
            className={style.arrowLeft}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              scrollToLeft();
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
            >
              <path
                d="M6.75 3.75L12 9L6.75 14.25"
                stroke="#00111A"
                stroke-width="1.2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
        ) : null}
        {/* </div> */}
        <div className={style.dotImageIndexes}>
          <ActiveDotsAsIndexes index={indImg} imgLen={imgLength} />
        </div>

        {listing.virtual_tour ? (
          <>
            <div className={style.VtourCon}>
              <div className={`${style.Vtour}`}>
                <svg
                  width="14"
                  height="16"
                  viewBox="0 0 14 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    id="Vector"
                    d="M12.9903 10.773C12.9887 10.6326 12.9893 10.4907 12.9903 10.3456V4.72845C12.9671 4.52397 12.8735 4.37573 12.6652 4.25221C10.9075 3.21456 9.15516 2.1685 7.40664 1.11719C7.15399 0.965278 6.94678 0.957919 6.68818 1.11351C4.92397 2.17481 3.15489 3.22928 1.37823 4.27113C1.14884 4.4057 1.03686 4.55919 1.00818 4.78417C1.00223 4.82832 0.999527 4.87511 1.00007 4.92505C1.01089 6.07308 1.00007 7.22058 1.00818 8.36862C1.00872 8.46113 1.00926 8.55417 1.01035 8.64669C1.01089 8.6777 1.00981 8.70609 1.00818 8.73342V11.4432C1.0493 11.593 1.14938 11.7018 1.31655 11.7975C3.08618 12.8157 4.85148 13.8412 6.61352 14.8726C6.91 15.0455 7.16914 15.0418 7.46236 14.8652C9.18005 13.8312 10.901 12.801 12.6289 11.7828C12.8453 11.655 12.959 11.5084 12.9903 11.3023C12.999 11.2466 13.0017 11.1872 12.999 11.1225C12.9941 11.0064 12.9914 10.8902 12.9903 10.773ZM6.62543 13.7566C6.62543 13.8055 6.61352 13.8549 6.60379 13.9274C6.51452 13.8817 6.44365 13.8491 6.37656 13.8102C4.91369 12.9576 3.45027 12.106 1.99173 11.2461C1.90354 11.194 1.80508 11.0694 1.80454 10.978C1.79372 9.17024 1.79697 7.36251 1.79751 5.55478C1.79751 5.52324 1.80508 5.4917 1.81266 5.43178C1.89705 5.47488 1.95927 5.50379 2.01824 5.53796C3.48869 6.39531 4.96022 7.25107 6.42526 8.11735C6.51885 8.17255 6.61731 8.31132 6.61785 8.41172C6.62975 10.1932 6.62651 11.9751 6.62543 13.7566ZM6.88132 7.46449C5.3611 6.56825 3.83547 5.68146 2.31146 4.79153C2.28225 4.77418 2.2552 4.75263 2.18541 4.7048C3.0007 4.22067 3.78083 3.75809 4.56096 3.29499C5.32702 2.83977 6.09091 2.38087 6.86185 1.93406C6.94245 1.8878 7.09394 1.86678 7.16535 1.90883C8.69206 2.81138 10.2123 3.72497 11.7336 4.63699C11.7482 4.6454 11.7585 4.66169 11.7834 4.68692C11.7282 4.7274 11.6779 4.7705 11.6211 4.80467C10.1533 5.68462 8.68449 6.56246 7.21728 7.44346C7.10313 7.51232 7.0182 7.54439 6.88132 7.46449ZM11.9494 11.2624C10.5455 12.0913 9.14867 12.9308 7.74909 13.7661C7.66686 13.8155 7.58138 13.8596 7.46561 13.9238C7.45641 13.8228 7.44451 13.7498 7.44451 13.6772C7.44342 11.931 7.44072 10.1853 7.451 8.43958C7.45154 8.33392 7.52999 8.18464 7.61979 8.12997C9.08104 7.24319 10.5504 6.36797 12.0182 5.49118C12.0544 5.4691 12.0928 5.45175 12.1799 5.40655C12.1799 5.53533 12.1794 5.6126 12.1799 5.6904C12.1815 7.40982 12.1799 9.12977 12.1907 10.8492C12.1918 11.051 12.1242 11.1593 11.9494 11.2624Z"
                    fill="#00B4FF"
                    stroke="#00B4FF"
                  />
                </svg>
                {t("Visite 3D")}
              </div>
            </div>
          </>
        ) : null}
        <div className={style.label}>
          {
            // listing?.exclusivite &&
            listing?.vendu && listing.transaction_type === "Vente" ? (
              <div className={`${style.venduMark}`}>{t("Vendu")}</div>
            ) : (
              <div className={`${style.dateCreationList}`}>
                {listing[`date_${lang}`]
                  ? listing[`date_${lang}`]
                  : listing?.date
                  ? listing?.date.split("T")[0]
                  : ""}{" "}
              </div>
            )
          }
          {listing?.exclusivite ? (
            // && !listing?.vendu
            <div className={style.labelAnnonceVerified}>
              <svg
                width="17"
                height="18"
                viewBox="0 0 17 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.37559 9.00011L7.79226 10.4168L10.6256 7.58344M5.5502 3.82718C6.05845 3.78662 6.54096 3.58676 6.92903 3.25605C7.83462 2.48431 9.16657 2.48431 10.0722 3.25605C10.4602 3.58676 10.9427 3.78662 11.451 3.82718C12.637 3.92183 13.5789 4.86366 13.6735 6.04971C13.7141 6.55797 13.9139 7.04047 14.2446 7.42854C15.0164 8.33414 15.0164 9.66608 14.2446 10.5717C13.9139 10.9597 13.7141 11.4422 13.6735 11.9505C13.5789 13.1366 12.637 14.0784 11.451 14.173C10.9427 14.2136 10.4602 14.4135 10.0722 14.7442C9.16657 15.5159 7.83462 15.5159 6.92903 14.7442C6.54096 14.4135 6.05845 14.2136 5.5502 14.173C4.36414 14.0784 3.42232 13.1366 3.32767 11.9505C3.28711 11.4422 3.08725 10.9597 2.75654 10.5717C1.9848 9.66608 1.9848 8.33414 2.75654 7.42854C3.08725 7.04047 3.28711 6.55797 3.32767 6.04971C3.42232 4.86366 4.36414 3.92183 5.5502 3.82718Z"
                  stroke="white"
                  stroke-width="1.6"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span>{t("Exclu Agenz")}</span>
            </div>
          ) : null}
        </div>
      </div>
      {showDesc ? (
        <div className={style.moreImages}>
          <div className={style.pic}>
            <Image
              unoptimized
              priority={false}
              alt={buildListingTitle(listing, t, lang)}
              // fill
              width={0}
              height={148}
              style={{
                objectFit: "cover",
                objectPosition: "center",
                width: "100%",
                minWidth: "100%",
                scrollSnapAlign: "start",
              }}
              src={
                typeof listing.images[imgLength - 2] == "string"
                  ? buildUrlImageWithOperations(
                      listing.images[imgLength - 2],
                      false
                    )
                  : listing.images[imgLength - 2]
                  ? buildUrlImageWithOperations(
                      listing.images[imgLength - 2],
                      false
                    )
                  : "https://storage.googleapis.com/headers-agenz/logo-agenz/agenz-logo-white.png"
              }
            />
          </div>
          <div className={style.pic}>
            <Image
              unoptimized
              priority={false}
              alt={buildListingTitle(listing, t, lang)}
              // fill
              width={0}
              height={148}
              style={{
                objectFit: "cover",
                objectPosition: "center",
                width: "100%",
                minWidth: "100%",
                scrollSnapAlign: "start",
              }}
              src={
                typeof listing.images[imgLength - 1] == "string"
                  ? buildUrlImageWithOperations(
                      listing.images[imgLength - 1],
                      false
                    )
                  : listing.images[imgLength - 1]
                  ? buildUrlImageWithOperations(
                      listing.images[imgLength - 1],
                      false
                    )
                  : "https://storage.googleapis.com/headers-agenz/logo-agenz/agenz-logo-white.png"
              }
            />
          </div>
        </div>
      ) : null}
    </>
  );
}

export default index;
